import React from 'react';

interface InputProps extends React.HTMLProps<HTMLInputElement> {
  defaultValue?: string;
  disabled?: boolean;
  id?: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  type?: string;
  value?: string;
}

export function Input({
  defaultValue,
  disabled,
  id,
  label,
  placeholder,
  required,
  type,
  value,
  ...props
}: InputProps) {
  const asterisk = required ? <span className="required-indicator">*</span> : '';

  return (
    <div className="input">
      {label && (
        <label htmlFor={id} className="input-label">
          {label} {asterisk}
        </label>
      )}
      <input
        defaultValue={defaultValue}
        disabled={disabled}
        id={id}
        name={id}
        placeholder={placeholder || label}
        type={type}
        value={value}
        {...props}
      />
    </div>
  );
}
